import React, { useState, useContext, useEffect } from 'react'
import 'react-image-gallery/styles/css/image-gallery.css'
import AuthContext from '../../../../product/context/auth/authContext'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import {
    mapData,
    currencyFormat,
    handleRedirectInternal,
    formatPhone,
} from '../../../../product/common/components'
import { useHistory, Link } from 'react-router-dom'
import AlertContext from '@/product/context/alert/alertContext'
import CommentContext from '@/product/context/comment/commentContext'
import Comment from '@/custom/components/organisms/Comments/comment'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import SignContext from '@/custom/context/signContext'
import UserContext from '@/product/context/user/userContext'

const Comments = (props) => {
    const [product, setProduct] = useState({})
    const [comments, setComments] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const { handleLoginPopup } = useContext(SignContext)
    const userContext = useContext(UserContext)
    const {
        saveComment,
        responseStatus: commentStatus,
        getAllComments,
        clearResponse,
    } = useContext(CommentContext)

    const {
        updateProfile,
        responseStatus: userResponseStatus,
        clearResponse: userClearResponse,
    } = userContext

    const { user, isAuthenticated, loadUser } = authContext
    const [text, setText] = useState('')
    const { setAlert } = useContext(AlertContext)

    useEffect(() => {
        if (props?.product?.id > 0) {
            setProduct(props.product)
            getAllComments({
                project_id: props.product.id,
            })
        }
    }, [props?.product])

    const postComment = async (comment_level, text, commentId) => {
        saveComment({
            project_id: product?.id || 0,
            user_id: isAuthenticated ? user.id : 0,
            comment: text,
            comment_id: commentId,
            comment_level: comment_level,
        })
        setText('')
    }

    useEffect(() => {
        if (commentStatus) {
            if (commentStatus.from === 'saveComment' && commentStatus.status === 'success') {
                formik.values.comment = ''
                setAlert('Your question has been submitted.', commentStatus.status)
                props.toggleQuestion()
                clearResponse()
            }
            if (commentStatus?.from === 'getAllComments' && commentStatus?.status === 'success') {
                setComments(commentStatus.data)
            }
        }
    }, [commentStatus])

    const validationArray = Yup.object({
        name: Yup.string().required('Required!'),
        email: Yup.string().email('Invalid email format').required('Required!'),
        comment: Yup.string().required('Required!'),
        phone: user?.phone
            ? Yup.string()
            : Yup.string()
                  .trim()
                  .min(10, (obj) => {
                      if (obj?.value?.length) {
                          return 'Phone must be 10 digits'
                      }
                  })
                  .max(10, (obj) => {
                      if (obj?.value?.length) {
                          return 'Phone must be 10 digits'
                      }
                  })
                  .required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            project_id: props.product ? props.product.id : 0,
            user_id: isAuthenticated ? user.id : 0,
            comment: '',
            comment_id: '',
            comment_level: 0,
            phone: user?.phone ? formatPhone(user?.phone, true) : '',
            name: user?.first_name
                ? `${user?.first_name} ${user?.last_name ? user?.last_name : ''}`
                : '',
            email: user?.email ? user?.email : '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            formik.values.project_id = props.product ? props.product.id : 0
            values.project_id = props.product ? props.product.id : 0
            values.generalSettingEmail = true
            values.ccSeller = true
            values.user_email = values.email
            values.user_name = values.name
            if (user?.id && formatPhone(values.phone, true) !== user?.phone) {
                updateProfile(
                    { id: user.id, phone: formatPhone(values.phone) },
                    true,
                    'userPhoneUpdate',
                )
            }
            saveComment(values)
            setText('')
        },
    })

    useEffect(() => {
        if (user?.id && user?.phone) {
            formik.values.phone = formatPhone(user.phone, true)
        }
    }, [user])

    useEffect(() => {
        if (
            userResponseStatus?.from === 'userPhoneUpdate' &&
            userResponseStatus?.status === 'success'
        ) {
            loadUser()
            userClearResponse()
        }
    }, [userResponseStatus])

    const commentData = [
        {
            label: '',
            name: 'name',
            type: 'text',
            placeholder: 'Name*',
            // class: `${user?.first_name ? 'd-none' : 'col-12'}`,
            class: 'col-12',
            formik: formik,
        },
        {
            label: '',
            name: 'phone',
            type: 'text',
            placeholder: 'Phone',
            class: 'col-12',
            formik: formik,
        },
        {
            label: '',
            name: 'email',
            type: 'email',
            placeholder: 'Email*',
            class: 'col-12',
            formik: formik,
        },
        {
            label: '',
            name: 'comment',
            type: 'textarea',
            placeholder: 'Ask a question or leave a comment',
            class: 'col-12',
            formik: formik,
            // upperLabel: true,
        },
    ]

    const handleTextChange = (e) => {
        setText(e.target.value)
    }

    return (
        <>
            <div className="pv-comments-wrapper">
                <div className="comment-form-box clearfix">
                    <div className="form-group row mb-0">
                        {Object.values(mapData(commentData))}
                        {/* <textarea
                            rows="4"
                            className="form-control"
                            placeholder="Ask a question or leave a comment"
                            value={text}
                            onChange={handleTextChange}
                        ></textarea> */}
                    </div>
                    <div className="mt-2 mb-4">
                        <Link to={'/contact-us'} className="contactZip" target={'_blank'}>
                            Contact Zipperbuy Support
                        </Link>
                    </div>
                    <PrimaryButton
                        btnSize="askQuesBtn"
                        label="Submit"
                        onClick={formik.handleSubmit}
                    />
                    {/* {isAuthenticated ? (
                        <PrimaryButton
                            btnSize="askQuesBtn"
                            label="Submit"
                            onClick={formik.handleSubmit}
                        />
                    ) : (
                        <PrimaryButton
                            btnSize="mt-3"
                            label="Login to Ask Question"
                            onClick={handleLoginPopup}
                        />
                    )} */}
                </div>
                {/* {comments.map((data) =>
                    data.reply_count >= 1 && data.last_reply ? <Comment data={data} /> : '',
                )} */}
            </div>
        </>
    )
}
export default Comments
